import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../shared/services/app-config.service';
import { TenantModuleType } from '../shared/models/tenantModuleType';

@Injectable({ providedIn: 'root' })
export class ModuleGuardService {
  constructor(
    private appConfigService: AppConfigService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    let moduleType = route.data.moduleType as TenantModuleType;
    let tenant = this.appConfigService.tenant;

    if (!tenant) {
      return false;
    }

    let hasModule = this.hasModule(moduleType);
    if (!hasModule) {
      this.router.navigate(['not-found'], { skipLocationChange: true });
    }

    return hasModule;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }

  hasModule(moduleType: TenantModuleType): boolean {
    return this.appConfigService.tenant.modules.some((module) => module.moduleType === moduleType);
  }
}
